module.exports = __webpack_public_path__ + "img/chinese_lanterns.41f5fbff.jpg";